

































































import { defineComponent, reactive, computed, ref } from '@vue/composition-api';
import { getStore } from '../store';
import { useRouter } from '../router';
import { useClientChecker } from '../client-checker';
import { useI18n } from '../i18n';

const componentName = 'RegisterConfirm';

export default defineComponent({
    name: componentName,

    setup(context) {
        const store = getStore(), { router, route } = useRouter(), client = useClientChecker(), i18n = useI18n();

        const platform = route.value.query.platform;
        const clientId = route.value.query.client_id;
        const returnUrl = route.value.query.returnUrl;

        const tokenError = ref(false);

        async function checkToken() {
            let response = await store.dispatch('emailConfirm', {
                userId: route.value.query.u,
                code: route.value.query.c
            }).catch((error: any) => {
                tokenError.value = true;
                throw error;
            });
            if (response.result != 'OK') {
                tokenError.value = true;
            }
        }

        checkToken();

        const appName = () => {
            if (client.clientIsBliss2.value) {
                return 'Bliss 2';
            }
            if (client.clientIsBliss.value) {
                return 'Bliss';
            }
            if (client.clientIsToolbox.value) {
                return 'Toolbox NFC';
            }
            if (client.clientIsYesly.value) {
                return 'Yesly';
            }
        };

        const openAndroidText = i18n.t('accessRegisterConfirmOpenAppAndroid', { app: appName() }) as string;
        const openIosText = i18n.t('accessRegisterConfirmOpenAppIos', { app: appName() }) as string;

        const showAppLink = computed(() => {
            return client.clientIsBliss2.value ||
                client.clientIsBliss.value ||
                client.clientIsToolbox.value ||
                client.clientIsYesly.value;
        });

        const onContinueWeb = () => router.replace({ name: 'access-signin', query: route.value.query });

        const onContinueAppAndroid = () => {
            let appUrl = '';
            if (client.clientIsBliss2.value) {
                appUrl = 'market://details?id=com.findernet.Bliss2';
            }
            else if(client.clientIsBliss.value) {
                appUrl = 'market://details?id=com.findernet.appcrono';
            }
            else if(client.clientIsToolbox.value) {
                appUrl = 'market://details?id=com.findernet.ToolboxNFC';
            }
            else if(client.clientIsYesly.value) {
                appUrl = 'market://details?id=com.findernet.FinderHome';
            }
            window.location.replace(appUrl);
        }

        const onContinueAppIos = () => {
            let appUrl = '';
            if (client.clientIsBliss2.value) {
                appUrl = 'com.findernet.Bliss2://';
            }
            else if(client.clientIsBliss.value) {
                appUrl = 'com.findernet.Bliss2://';
            }
            else if(client.clientIsToolbox.value) {
                appUrl = 'finder://';
            }
            else if(client.clientIsYesly.value) {
                appUrl = 'itms-apps://apps.apple.com/it/app/yesly/id1398780077';
            }
            window.location.replace(appUrl);
        }

        return {
            platform,
            tokenError,
            openAndroidText,
            openIosText,
            showAppLink,
            onContinueWeb,
            onContinueAppAndroid,
            onContinueAppIos
        }
    }
})
